'use client';
import { getAgencyConfig } from './agency-config-helper';

interface IntroFormProps {
  onSubmit: (choice: 'sell' | 'rent') => void;
  dictionary: any;
  disableSubmit?: boolean;
  agencyId?: string;
  addRentingFlow?: boolean;
}

export function IntroForm({ onSubmit, dictionary, disableSubmit = false, agencyId, addRentingFlow }: IntroFormProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit('sell');
  };

  const agencyConfig = agencyId ? getAgencyConfig(agencyId) : null;
  const startingMessageKey = agencyConfig?.startingMessageOverrideKey || 'startingMessage';
  const startingMessage = dictionary?.sellingForm?.[startingMessageKey] || dictionary?.sellingForm?.startingMessage;

  if (addRentingFlow) {
    return (
      <div className="w-full">
        <p className="text-base md:text-sm text-zinc-800">
          {dictionary?.sellingForm?.rentOrSellPrompt || 'Hallo! 👋 Ik ben je digitale makelaar. Wat wil je vandaag schatten?'}
        </p>
        
        <div className="flex flex-row gap-2 mt-4">
          <button
            onClick={() => onSubmit('sell')}
            disabled={disableSubmit}
            className="px-4 py-2.5 bg-zinc-800 text-white rounded-lg text-sm font-medium transition-colors hover:bg-zinc-700 disabled:opacity-50 disabled:pointer-events-none"
          >
            {dictionary?.sellingForm?.woningButton || 'Woning'}
          </button>
          <button
            onClick={() => onSubmit('rent')}
            disabled={disableSubmit}
            className="px-4 py-2.5 bg-zinc-800 text-white rounded-lg text-sm font-medium transition-colors hover:bg-zinc-700 disabled:opacity-50 disabled:pointer-events-none"
          >
            {dictionary?.sellingForm?.huurprijsButton || 'Huurprijs'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <p className="text-base md:text-sm text-zinc-800">
        {startingMessage}
      </p>
      
      <form onSubmit={handleSubmit} className="mt-4">
        <button
          type="submit"
          disabled={disableSubmit}
          className="px-4 py-2.5 bg-zinc-800 text-white rounded-lg text-sm font-medium transition-colors hover:bg-zinc-700 disabled:opacity-50 disabled:pointer-events-none"
        >
          {dictionary?.sellingForm?.readyResponse}
        </button>
      </form>
    </div>
  );
}